import { ThemeMode } from '@/store/types';
import { getLang } from '@/utils/device';

const state = {
    lang: getLang(),
    // lang: Lang.zhCN,
    // 主题模式， 系统的主题
    themeMode: ThemeMode.light,
};

const mutations = {
    SetAny: (state, objData) => {
        if (Object.prototype.toString.call(objData) === '[object Object]') {
            Object.keys(objData).forEach((key) => {
                state[key] = objData[key];
            });
        }
    },
};

const actions = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
